import { render, staticRenderFns } from "./StorageIcon.vue?vue&type=template&id=3d74fff5"
import script from "./StorageIcon.vue?vue&type=script&lang=js"
export * from "./StorageIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports